function initMapServices( ) { 
    "use strict";
    $( '.facility-trigger' ).click( function( ) {
    	var $this = $(this);
    	var target = $this.data('target');

        
    	if($this.hasClass('active')){
    		$('.svg-map #'+target).attr("class", " ");

    	}else{
    		$('.svg-map #'+target).attr("class", "active-point");
            removeService();
    	}    
    	$this.toggleClass('active');	  

    	$('.svg-map #'+target).toggleClass('active-point');
    	return false;
    		
    } );   
}  
function removeService(){
    var $this = $(".facility-trigger.active");
    var target = $this.data('target');
    $this.removeClass('active');     
    $('.svg-map #'+target).attr("class", " ");
}


function initMooringApplicationForm() {    

    $('#mooring-application-form').validate({
        submitHandler: function() {

             if (typeof (grecaptcha) !== 'undefined') {
                grecaptcha.ready(function () {
                    grecaptcha.execute(RECAPTCHA_KEY, { action: 'submit' }).then(function (token) {
                     $('#mooring-application-form').append('<input class="gr-recaptcha" name="g-recaptcha-response" type="hidden" value="'+token+'"/>');
                        var submitButton = $('#mooring-application-form button[type="submit"]');
                        submitButton.attr('disabled','disabled');

                             var data = $('#mooring-application-form').serialize();
                             var object = {
                                success: function (response){
                                    $('#mooring-application-form .form-response').removeClass('alert-success');
                                    $('#mooring-application-form .form-response').removeClass('alert-danger');

                                   if(response['status']=='ok'){
                                        $('#mooring-application-form .form-response').addClass('alert-success').show().html(response['message']);
                                         $('#mooring-application-form')[0].reset();
                                          submitButton.removeAttr('disabled');
                                         if($('#mooring-application-form').find('.gr-recaptcha').length>0 ){
                                            $('#mooring-application-form').find('.gr-recaptcha').remove();
                                        }
                                      setTimeout(function () {
                                           window.location.reload();
                                        }, 3000);
                                    }else{
                                         submitButton.removeAttr('disabled');
                                        if($('#mooring-application-form').find('.gr-recaptcha').length>0 ){
                                            $('#mooring-application-form').find('.gr-recaptcha').remove();
                                        }
                                        $('#mooring-application-form .form-response').addClass('alert-danger').show().html(response['message']);
                                    }
                                },
                                error: function (data) {
                                    submitButton.removeAttr('disabled');
                                    if($('#mooring-application-form').find('.gr-recaptcha').length>0 ){
                                        $('#mooring-application-form').find('.gr-recaptcha').remove();
                                    }
                                    $('#mooring-application-form .form-response').addClass('alert-danger').show().html(data['message']);
                                },
                                'data' : data
                            };
                            
                            $.ajax(object);
                            return false;

                       });
                });
             }


            
        },
        errorPlacement: function(error, element) {
            // error.hide();
        },
        highlight: function (element, errorClass, validClass) {
            $(element).parent().find('.form-control-feedback').remove();
             $(element).closest('.form-group').append('<span class=" form-control-feedback"><i class="fa fa-exclamation-triangle"></i></span>');
             $(element).parent().addClass('has-error has-feedback');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).parent().find('.form-control-feedback').remove();
             $(element).parent().removeClass('has-error has-feedback');
        }
    });



}
